import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MtnaDialogButton, MtnaDialogComponent, MtnaDialogData } from '@mtna/core-angular';
import { RdsApiService, RdsDialogLink, RdsTextItem, RdsTextLink } from '@rds/shared-api';

/**
 * Common application footer, populated by an external configuration.
 *
 * @author Will Davis <will.davis@mtna.us
 */
@Component({
  selector: 'rds-c-app-footer',
  template: `
    <footer>
      <ul fxLayout="row">
        <li *ngFor="let item of items">
          <ng-container [ngSwitch]="item | rdsAppFooterItemType">
            <a *ngSwitchCase="'LINK'" [attr.href]="$any(item).url" target="_blank">
              {{ item.text }}
            </a>
            <button *ngSwitchCase="'DIALOG'" type="button" (click)="handleRdsDialogLink($any(item))">{{ item.text }}</button>
            <ng-template [ngSwitchCase]="'TEXT'">{{ item.text }}</ng-template>
          </ng-container>
        </li>
      </ul>
    </footer>
  `,
  styleUrls: ['./app-footer.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RdsAppFooterComponent {
  items: Array<RdsTextItem | RdsTextLink | RdsDialogLink> | undefined = this.rdsApiService.getConfig('footerItems');

  constructor(private dialog: MatDialog, private rdsApiService: RdsApiService) {}

  handleRdsDialogLink(item: RdsDialogLink) {
    this.dialog.open(MtnaDialogComponent, {
      maxWidth: '600px',
      data: new MtnaDialogData(item.text, item.dialog, [new MtnaDialogButton($localize`CLOSE`)]),
    });
  }
}
